// Shows the newest unread KalTiQ announcement above the chat list. Dismissal is remembered per browser.
import React from 'react';

const SEEN_KEY = 'kaltiq-announcement-seen';

export default class AnnouncementBanner extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {item: null};
    this.dismiss = this.dismiss.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.load();
  }

  componentDidUpdate(prevProps) {
    // Load again once the connection (and so the auth token) becomes available.
    if (this.props.connected && !prevProps.connected) {
      this.load();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  async load() {
    if (!this.props.connected) return;
    try {
      const list = await this.props.kaltiq.announcements();
      const seen = parseInt(localStorage.getItem(SEEN_KEY) || '0', 10);
      const item = (list || []).find(a => a.id > seen) || null;
      if (this._mounted) this.setState({item});
    } catch (_) {
      // Announcements are optional: stay silent when the server doesn't have them.
    }
  }

  dismiss() {
    const item = this.state.item;
    if (item) {
      try { localStorage.setItem(SEEN_KEY, String(item.id)); } catch (_) { /* ignore */ }
    }
    this.setState({item: null});
    // Show the next unread one, if any.
    this.load();
  }

  render() {
    const item = this.state.item;
    if (!item) return null;
    return (
      <div className="kq-announcement" role="status">
        <i className="material-icons">campaign</i>
        <div className="kq-announcement-text">
          <b>{item.title}</b>
          <div>{item.body}</div>
        </div>
        <a href="#" className="kq-announcement-close" aria-label="Dismiss" onClick={e => {e.preventDefault(); this.dismiss();}}>
          <i className="material-icons">close</i>
        </a>
      </div>
    );
  }
};
